import React from 'react'
import MaterialSymbol from '../material-symbol'

const DeleteForever = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="delete_forever" {...props} />
))

DeleteForever.displayName = 'DeleteForever'

export default DeleteForever
